package com.ustadmobile.core.schedule

class ClazzLogCreatorManagerJs: ClazzLogCreatorManager {

    override fun requestClazzLogCreation(clazzUid: Long, endpointUrl: String, fromTime: Long, toTime: Long) {

    }
}